/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Group, Paper, Space } from '@mantine/core';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import { EventDestinationType, EventType } from '../../../../../../../models/core/events.type';
import { Feature } from '../../../../../../../utils/constants.utils';
import EventDestinationItem from './EventDestinationItem';
import EventDestinationQuotation from './EventDestinationQuotation';

type DataViewProps = {
  data: EventDestinationType;
  event: EventType;
};

export default function EventDestinationView(props: DataViewProps) {
  return (
    <div>
      <Paper shadow="xs" p="md" withBorder>
        <PageSection
          size="lg"
          color={Feature.Home.Event.color}
          label="Destino Final"
          text="Detalhes do destino final."
        />
        <Space h="xs" />
        <EventDestinationItem data={props.data} />
      </Paper>
      <Space h="lg" />

      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between">
          <PageSection
            size="lg"
            color={Feature.Home.Event.color}
            label="Fornecedor"
            text="Detalhes do fornecedor."
          />
        </Group>
        <Space h="xs" />
        <EventDestinationQuotation
          data={props.data.cotacao}
          compra={props.event.referencia!.contrato.residuo!.compra}
        />
      </Paper>
    </div>
  );
}
